import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Box } from '../box';
import { useTypography } from '../../hooks/useTypography';
import { useBackgroundColor } from '../../hooks/useColor';
import styles from './styles.module.css';
const TypographyIcon = forwardRef(function TypographyIcon(props, ref) {
    return (React.createElement(TypographyWithRef, { ref: ref, ...props, className: cn(props.className, styles[props.variant], styles.icon) }, React.Children.toArray(props.children).map((x, i) => typeof x === 'string' ? React.createElement("span", { key: i }, x) : x)));
});
const TEXT_TO_BG_COLOR_MAP = {
    ['main']: 'text',
    ['minor']: 'textMinor',
    ['invert']: 'textInvert',
    ['error']: 'error',
    ['inherit']: 'inherit',
    ['success']: 'success',
    ['warning']: 'warning',
    ['info']: 'info',
};
const TypographyNav = forwardRef(function TypographyIcon(props, ref) {
    var _a;
    const bgClass = useBackgroundColor(TEXT_TO_BG_COLOR_MAP[(_a = props.color) !== null && _a !== void 0 ? _a : 'main']);
    return (React.createElement(TypographyWithRef, { ref: ref, ...props, className: cn(props.className, styles[props.variant], styles.nav) },
        React.Children.toArray(props.children).map((x, i) => typeof x === 'string' ? React.createElement("span", { key: i }, x) : x),
        React.createElement("span", { className: cn(styles.navIcon, bgClass), role: "icon" })));
});
const TypographyWithRef = forwardRef(function TypographyWithRef(props, ref) {
    const { variant, className, thickness, group, children, color, Component, ...rest } = props;
    const { className: typographyClasses, DefaultComponent } = useTypography({
        variant,
        thickness,
        group,
        color,
        className,
    });
    return (React.createElement(Box, { ref: ref, Component: Component || DefaultComponent, className: typographyClasses, ...rest }, children));
});
export const Typography = Object.assign(TypographyWithRef, {
    Icon: TypographyIcon,
    Nav: TypographyNav,
});
